// import axios from 'axios'

export default async function isMaintenance({ next }) {
  // await axios.get(process.env.VUE_APP_SERVER_BASE_URL + 'api/v1/mock')

  return next()
}
